import classNames from 'classnames';

export function MiniTrendSparkline({
  changePercentage,
  deltaSuffix = '%',
}: {
  changePercentage: number | null;
  deltaSuffix?: string;
}) {
  const changeLabel =
    changePercentage == null
      ? '—'
      : changePercentage > 0
        ? `+${changePercentage}${deltaSuffix}`
        : changePercentage < 0
          ? `${changePercentage}${deltaSuffix}`
          : `0${deltaSuffix}`;

  return (
    <div className="d-flex flex-shrink-0 flex-column align-items-center gap-1" style={{ width: '4.5rem' }}>
      <div className="rounded-2 bg-body-tertiary" style={{ height: '1.75rem', width: '3.5rem' }} aria-hidden />
      <span
        className={classNames('fs--2 fw-semibold', {
          'text-300': changePercentage == null,
          'text-success': changePercentage != null && changePercentage > 0,
          'text-danger': changePercentage != null && changePercentage < 0,
          'text-500': changePercentage === 0,
        })}
        style={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {changeLabel}
      </span>
    </div>
  );
}
